function validationsChecks(field, myevent = null, errorObj) {
	const fieldContainer = field.parentNode;
	const emptyfield = fieldContainer.querySelector(".emptyField");
	if (myevent) {
		field.addEventListener(myevent, function () {
			if (validateCheckbox(field)) {
				emptyfield && emptyfield.classList.remove("active");
				fieldContainer.classList.remove("errored");
				errorObj[field.id] = true;
			} else {
				emptyfield && emptyfield.classList.add("active");
				fieldContainer.classList.add("errored");
				errorObj[field.id] = false;
			}
		});
	} else {
		if (validateCheckbox(field)) {
			emptyfield && emptyfield.classList.remove("active");
			fieldContainer.classList.remove("errored");
			errorObj[field.id] = true;
		} else {
			emptyfield && emptyfield.classList.add("active");
			fieldContainer.classList.add("errored");
			errorObj[field.id] = false;
		}
	}
}

//we need a data atribute containing the error node id on the first radio element ie field[0]
function validationsRadios(field, myevent = null, errorObj) {
	if (myevent) {
		//checking for choice correction
		field.forEach((element) => {
			element.addEventListener(myevent, function () {
				document
					.getElementById(field[0].dataset.error)
					.classList.remove("active");
			});
		});

		//checking on submit
	} else {
		const radios = field;
		const selected = [...radios].some((radio) => radio.checked);

		if (!selected) {
			document.getElementById(field[0].dataset.error).classList.add("active");
		}
	}
}

function validationsSelects(field, myevent = null, errorObj) {
	const fieldContainer = field.parentNode;
	const emptyfield = fieldContainer.querySelector(".emptyField");
	if (myevent) {
		field.addEventListener(myevent, function () {
			if (field.selectedIndex == 0) {
				emptyfield && emptyfield.classList.add("active");
				fieldContainer.classList.add("errored");
				errorObj[field.id] = false;
			} else {
				emptyfield && emptyfield.classList.remove("active");
				fieldContainer.classList.remove("errored");
				errorObj[field.id] = true;
			}
		});
	} else {
		if (field.selectedIndex == 0) {
			emptyfield && emptyfield.classList.add("active");
			fieldContainer.classList.add("errored");
			errorObj[field.id] = false;
		} else {
			emptyfield && emptyfield.classList.remove("active");
			fieldContainer.classList.remove("errored");
			errorObj[field.id] = true;
		}
	}
}

function validateDestinationOnSubmit(errorObj) {
	var valid = false;
	const errorElement = document.getElementById("destinationErrorMessage");
	var errorMultiElement = document.getElementById(
		"destinationMultiErrorMessage"
	);
	var selectedCount = 0;
	const field = document.querySelectorAll(".js-validateDestinationOnChange");
	const unknownCheck = document.getElementById("destinationUnknown");
	errorObj["destination"] = false;
	if (
		document.getElementById("country").selectedIndex != 0 ||
		document.getElementById("placeInGreece").selectedIndex != 0 ||
		document.getElementById("destinationUnknown").checked
	) {
		var valid = true;
		errorObj["destination"] = true;
	}

	selectedCount = document.querySelectorAll(".dstSelected").length;

	if (selectedCount == 0) {
		errorMultiElement.classList.remove("active");
		errorObj["destination"] = true;
	}
	if (selectedCount == 1) {
		errorMultiElement.classList.remove("active");
		errorObj["destination"] = true;
	}
	if (selectedCount > 1) {
		errorMultiElement.classList.add("active");
		errorObj["destination"] = false;
	}

	if (valid == false) {
		errorElement.classList.add("active");
	} else {
		errorElement.classList.remove("active");
	}
}

function validateDestination(errorObj) {
	const errorElement = document.getElementById("destinationErrorMessage");
	const field = document.querySelectorAll(".js-validateDestinationOnChange");
	const unknownCheck = document.getElementById("destinationUnknown");
	errorObj["destination"] = false;

	field.forEach((element) => {
		element.addEventListener("change", function () {
			if (this.selectedIndex != 0 && this.classList.contains("select-plain")) {
				this.classList.add("dstSelected");
				errorElement.classList.remove("active");
				errorObj["destination"] = true;
			} else {
				this.classList.remove("dstSelected");
			}
		});
	});
	unknownCheck.addEventListener("change", function () {
		if (this.checked) {
			this.classList.add("dstSelected");
			errorElement.classList.remove("active");
			errorObj["destination"] = true;
		} else {
			this.classList.remove("dstSelected");
		}
	});
}

function validateTripDatesOnSubmit(errorObj) {
	var valid = false;
	const errorElement = document.getElementById("datesErrorMessage");
	var errorMultiElement = document.getElementById("datesMultiErrorMessage");
	var selectedCount = 0;

	errorObj["tripDates"] = false;
	if (
		document.getElementById("season").selectedIndex != 0 ||
		document.getElementById("tripDates").value != "" ||
		document.getElementById("datesUnknown").checked
	) {
		var valid = true;
		errorObj["tripDates"] = true;
	}

	selectedCount = document.querySelectorAll(".datesSelected").length;
	console.log("gggggg", valid);

	if (selectedCount == 0) {
		errorMultiElement.classList.remove("active");
		errorObj["tripDates"] = true;
	}
	if (selectedCount == 1) {
		errorMultiElement.classList.remove("active");
		errorObj["tripDates"] = true;
	}
	if (selectedCount > 1) {
		errorMultiElement.classList.add("active");
		errorObj["tripDates"] = false;
	}

	if (valid == false) {
		errorElement.classList.add("active");
	} else {
		errorElement.classList.remove("active");
	}
}

function validateTripDates(errorObj) {
	const errorElement = document.getElementById("datesErrorMessage");
	const field = document.querySelectorAll(".js-validateDatesOnChange");
	const unknownDatesCheck = document.getElementById("datesUnknown");
	const datesRange = document.getElementById("tripDates");
	errorObj["tripDates"] = false;

	field.forEach((element) => {
		element.addEventListener("change", function () {
			if (this.selectedIndex != 0 && this.classList.contains("select-plain")) {
				this.classList.add("datesSelected");
				errorElement.classList.remove("active");
				errorObj["tripDates"] = true;
			} else {
				this.classList.remove("datesSelected");
			}
		});
	});
	unknownDatesCheck.addEventListener("change", function () {
		if (this.checked) {
			this.classList.add("datesSelected");
			errorElement.classList.remove("active");
			errorObj["tripDates"] = true;
		} else {
			this.classList.remove("datesSelected");
		}
	});

	datesRange.addEventListener("input", function () {
		if (datesRange.value == "") datesRange.classList.remove("datesSelected");
	});
}

function validationField(field, myevent = null, myFunc = null, errorObj) {
	const fieldContainer = field.parentNode;
	const wrongfield = fieldContainer.querySelector(".wrongField");
	const emptyfield = fieldContainer.querySelector(".emptyField");
	if (myevent) {
		field.addEventListener(myevent, () => {
			console.log("after event", fieldContainer, wrongfield, emptyfield, field);
			if (field.value == "") {
				emptyfield && emptyfield.classList.add("active");
				fieldContainer.classList.add("errored");
				wrongfield && wrongfield.classList.remove("active");
				errorObj[field.id] = false;
			} else {
				if (myFunc) {
					if (myFunc(field)) {
						emptyfield && emptyfield.classList.remove("active");
						wrongfield && wrongfield.classList.remove("active");
						fieldContainer.classList.remove("errored");
						errorObj[field.id] = true;
					} else {
						emptyfield && emptyfield.classList.remove("active");
						wrongfield && wrongfield.classList.add("active");
						fieldContainer.classList.add("errored");
						errorObj[field.id] = false;
					}
				} else {
					fieldContainer.classList.remove("errored");
					emptyfield && emptyfield.classList.remove("active");
					errorObj[field.id] = true;
				}
			}
		});
	} else {
		if (field.value == "") {
			emptyfield && emptyfield.classList.add("active");
			fieldContainer.classList.add("errored");
			wrongfield && wrongfield.classList.remove("active");
			errorObj[field.id] = false;
		} else {
			console.log(myFunc);
			if (myFunc) {
				if (myFunc(field)) {
					emptyfield && emptyfield.classList.remove("active");
					wrongfield && wrongfield.classList.remove("active");
					fieldContainer.classList.remove("errored");
					errorObj[field.id] = true;
				} else {
					emptyfield && emptyfield.classList.remove("active");
					wrongfield && wrongfield.classList.add("active");
					fieldContainer.classList.add("errored");
					errorObj[field.id] = false;
				}
			} else {
				fieldContainer.classList.remove("errored");
				emptyfield && emptyfield.classList.remove("active");
				errorObj[field.id] = true;
			}
		}
	}
}

// VALIDATE MAIL FUNCTION
function validateMail(elem) {
	if (
		elem.value.match(/^([\w-.]+@([\w-]+\.)+[\w-]{2,6})?$/) == null ||
		elem.length < 2
	) {
		//   Have errors
		return false;
	} else {
		//   Don't have errors
		return true;
	}
}

// VALIDATE IF TEXT FIELD, ALLOWS ONLY LETTERS ,UP TO 2 SPACES AND DOTS
function validateText(elem) {
	if (
		elem.value.match(/^[α-ωΑ-Ωa-zA-ZάΆήΉίΊέΈόΌύΎώΏ.\s]*$/) == null ||
		(elem.value.match(/\s/g) != null && elem.value.match(/\s/g).length >= 3) ||
		(elem.value.match(/\./g) != null && elem.value.match(/\./g).length >= 2) ||
		elem.value.length < 2
	) {
		//   Have errors
		return false;
	} else {
		//   Don't have errors
		return true;
	}
}

// VALIDATE FIELD FOR PHONE NUMBER, ALLOWS ONLY NUMBERS MINIMUM LENGTH 10 DIGITS
function validatePhone(elem) {
	if (elem.value.match(/^[0-9 +()]*$/) == null || elem.value.length < 10) {
		//   Have errors
		return false;
	} else {
		//   Dont have errors
		return true;
	}
}

function validateCheckbox(elem) {
	// if (jQuery(elem).is(':checked')) {
	if (elem.checked) {
		return true;
	} else {
		return false;
	}
}

function validateRadio(elem) {
	console.log(elem);
	if (elem.checked) {
		return true;
	} else {
		return false;
	}
}

// Age validator
// You need both getAge and checkAge
function getAge(birthDateString) {
	var today = new Date();
	var birthDate = new Date(birthDateString);
	var age = today.getFullYear() - birthDate.getFullYear();
	var m = today.getMonth() - birthDate.getMonth();
	if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
		age--;
	}
	return age;
}

function checkAge(elem) {
	if (getAge(elem.value) >= 18) {
		return true;
	} else {
		return false;
	}
}

export {
	validationsChecks,
	validationsRadios,
	validationsSelects,
	validationField,
	validateMail,
	validatePhone,
	validateCheckbox,
	validateText,
	checkAge,
	getAge,
	validateDestination,
	validateDestinationOnSubmit,
	validateTripDatesOnSubmit,
	validateTripDates,
};
